<div>
    <button type="button"
    class="btn bg-primary flex items-center justify-center
           absolute top-5 right-3 mb-7"
    (click)="modal21.open()">
    + Nuevo vehículo
</button>

  <ngx-custom-modal #modal21 customClass="modal-center absolute z-50 backdrop-blur-lg animate animate-fade-in-right auth-modal modal-wide">
    <!-- Modal Header -->
    <ng-template #modalHeader class="absolute z-50">
      <div>
        <h1 class="text-center text-3xl font-bold text-white dark:text-black">Registrar Vehículo 🚗🏍️</h1>
        <!-- <h1 class="text-center text-3xl font-bold text-white dark:text-black"><img src="../../../../../assets/images/title-cars1.gif" alt="" /></h1> -->
      </div>
    </ng-template>

    <!-- Modal Body -->
    <ng-template #modalBody>
      <!-- Reative form -->
      <form [formGroup]="vehicleForm" (ngSubmit)="onSubmit()">
        <div class="flex flex-wrap md:flex-nowrap gap-4 mb-4">
          <select type="text" formControlName="typevehicle" class="form-input ltr:pl-10 rtl:pr-10">
            <option value="" disabled selected>Selecciona el tipo de vehiculo</option>
            <option *ngFor="let vehicle of listVehicleTypesAll" [value]="vehicle._id">{{ vehicle.name }}</option>
          </select>
          <!-- <select class="w-full p-2 border border-primary  rounded-lg focus:ring focus:ring-blue-300" formControlName="selectCategory" (change)="onSelectCategoryChange()">
            <option value="" disabled selected>{{ 'WORKSHOP-FORM.SELECT-TYPE-VEHICLE' | translate }} </option>
            <option *ngFor="let category of serviceCenterCategories" [value]="category._id">{{ category.name }}</option>
          </select> -->

          <div *ngIf="vehicleForm.get('typevehicle')?.invalid && vehicleForm.get('typevehicle')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('typevehicle')?.errors?.['required']"> Ingresa tipo de vehiculo </small>
          </div>
        </div>

        <div class="flex flex-wrap md:flex-nowrap gap-4 mb-4">
          <div class="half w-full md:w-1/2">
            <select formControlName="brand" class="form-input ltr:pl-10 rtl:pr-10">
              <option value="" disabled selected>Selecciona la marca</option>
              <option *ngFor="let brand of vehicleBrands" [value]="brand.NOMBRE">{{ brand.NOMBRE }}</option>
            </select>
          </div>

          <!-- Campo: Modelo -->
          <div class="half w-full md:w-1/2">
            <input type="text" formControlName="modelo" placeholder="Modelo" class="form-input ltr:pl-10 rtl:pr-10" />
            <div *ngIf="vehicleForm.get('modelo')?.invalid && vehicleForm.get('modelo')?.touched" class="text-red-500">
              <small *ngIf="vehicleForm.get('modelo')?.errors?.['required']"> Ingresa el modelo </small>
            </div>
          </div>
        </div>

        <!-- Campo: Año -->
        <div class="flex flex-wrap md:flex-nowrap gap-4">
          <div class="half w-full md:w-1/2">
            <input type="number" formControlName="km" placeholder="Kilometraje" class="form-input ltr:pl-10 rtl:pr-10" />
            <div *ngIf="vehicleForm.get('km')?.invalid && vehicleForm.get('km')?.touched" class="text-red-500">
              <small *ngIf="vehicleForm.get('km')?.errors?.['required']"> Ingresa el kilometraje </small>
            </div>
          </div>

          <!-- Campo: Placa -->
          <div class="half w-full md:w-1/2">
            <input type="text" formControlName="plate" placeholder="placa" class="form-input ltr:pl-10 rtl:pr-10" />
            <div *ngIf="vehicleForm.get('plate')?.invalid && vehicleForm.get('plate')?.touched" class="text-red-500">
              <small *ngIf="vehicleForm.get('plate')?.errors?.['required']"> Ingresa la placa </small>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap md:flex-nowrap gap-4">
          <div class="half w-full md:w-1/2 pt-4">
            <input type="text" formControlName="year" placeholder="Año" class="form-input ltr:pl-10 rtl:pr-10" />
            <div *ngIf="vehicleForm.get('year')?.invalid && vehicleForm.get('year')?.touched" class="text-red-500">
              <small *ngIf="vehicleForm.get('year')?.errors?.['required']"> Ingresa el año </small>
            </div>
          </div>

          <div class="half w-full md:w-1/2 pt-4">
            <select formControlName="country" (change)="onPaisChange()" class="form-input ltr:pl-10 rtl:pr-10">
              <option value="" disabled selected>Selecciona el país</option>
              <option *ngFor="let country of countries" [value]="country.cca2">{{ country.name.common }}</option>
            </select>
            <div *ngIf="vehicleForm.get('country')?.invalid && vehicleForm.get('country')?.touched" class="text-red-500">
              <small *ngIf="vehicleForm.get('country')?.errors?.['required']"> Selecciona el país </small>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap md:flex-nowrap gap-4">
          <div class="half w-full md:w-1/2 pt-4">
            <select formControlName="state" (change)="onStateChange()" class="form-input ltr:pl-10 rtl:pr-10" [disabled]="!states.length">
              <option value="" disabled selected>Selecciona el departamento</option>
              <option *ngFor="let state of states" [value]="state.state_code">{{ state.state_name }}</option>
            </select>
            <div *ngIf="vehicleForm.get('state')?.invalid && vehicleForm.get('state')?.touched" class="text-red-500">
              <small *ngIf="vehicleForm.get('state')?.errors?.['required']"> Selecciona el departamento </small>
            </div>
          </div>

          <div class="half w-full md:w-1/2 pt-4">
            <select formControlName="city" class="form-input ltr:pl-10 rtl:pr-10" [disabled]="!cities.length">
              <option value="" disabled selected>Selecciona la ciudad</option>
              <option *ngFor="let city of cities" [value]="city.city_code">{{ city.city_name }}</option>
            </select>
            <div *ngIf="vehicleForm.get('city')?.invalid && vehicleForm.get('city')?.touched" class="text-red-500">
              <small *ngIf="vehicleForm.get('city')?.errors?.['required']"> Selecciona la ciudad </small>
            </div>
          </div>
        </div>

        <!-- Campo: Color -->
        <div class="relative mb-4 mt-4">
          <input type="text" id="color" formControlName="color" readonly placeholder="Selecciona el color de tu vehiculo" class="form-input cursor-pointer" />
          <p class="text-xs text-gray-500 mt-1">Haz clic en un círculo para seleccionar el color</p>
          <!-- Opciones de color en forma de círculos -->
          <div class="flex gap-2 mt-2">
            <button
              type="button"
              (click)="selectColor('ROJO')"
              [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500 border border-primary': vehicleForm.get('color')?.value === 'ROJO' }"
              class="w-8 h-8 rounded-full bg-red-500"
            ></button>
            <button
              type="button"
              (click)="selectColor('VERDE')"
              [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'VERDE' }"
              class="w-8 h-8 rounded-full bg-green-500 border border-primary"
            ></button>
            <button
              type="button"
              (click)="selectColor('AMARILLO')"
              [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'AMARILLO' }"
              class="w-8 h-8 rounded-full bg-yellow-500 border border-primary"
            ></button>
            <button
              type="button"
              (click)="selectColor('AZUL')"
              [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'AZUL' }"
              class="w-8 h-8 rounded-full bg-blue-500 border border-primary"
            ></button>
            <button
              type="button"
              (click)="selectColor('NEGRO')"
              [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'NEGRO' }"
              class="w-8 h-8 rounded-full bg-black border border-primary"
            ></button>
            <button
              type="button"
              (click)="selectColor('BLANCO')"
              [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'BLANCO' }"
              class="w-8 h-8 rounded-full bg-white border border-primary"
            ></button>
          </div>
        </div>

        <button type="submit" class="btn btn-primary w-full">Registrar Vehículo</button>
      </form>
    </ng-template>
  </ngx-custom-modal>
</div>
